import React from 'react';
import styled from 'styled-components';
import { FaSms, FaPhoneAlt, FaEnvelope } from 'react-icons/fa';

// How the customer asked to be reached, captured by the website quote form and
// stored on Lead.preferred_contact ('text' | 'call' | 'email'). Older leads have
// null — the website only started asking recently — so this renders nothing
// rather than guessing a default.
//
// Colors intentionally match the phone/sms/email entries in OriginBadge so the
// two badges read as one family when they sit side by side.
const CONTACT_CONFIG = {
  text:  { label: 'Text',  full: 'Text Message', color: '#9B59B6', Icon: FaSms },
  call:  { label: 'Call',  full: 'Phone Call',   color: '#16A085', Icon: FaPhoneAlt },
  email: { label: 'Email', full: 'Email',        color: '#F39C12', Icon: FaEnvelope },
};

export const getPreferredContactConfig = (value) =>
  (value && CONTACT_CONFIG[String(value).toLowerCase()]) || null;

export const preferredContactLabel = (value) =>
  getPreferredContactConfig(value)?.full || null;

const Badge = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 3px 9px;
  border-radius: 12px;
  font-size: ${p => (p.size === 'sm' ? '0.68rem' : '0.75rem')};
  font-weight: 600;
  line-height: 1.2;
  background: ${p => p.color}22;
  color: ${p => p.color};
  border: 1px solid ${p => p.color}44;
  white-space: nowrap;
  vertical-align: middle;

  svg {
    font-size: ${p => (p.size === 'sm' ? '0.65rem' : '0.75rem')};
    flex-shrink: 0;
  }
`;

const PreferredContactBadge = ({ value, size, style, title }) => {
  const config = getPreferredContactConfig(value);
  if (!config) return null;

  const { label, full, color, Icon } = config;

  return (
    <Badge
      color={color}
      size={size}
      style={style}
      title={title || `Preferred contact method: ${full}`}
    >
      <Icon />
      Prefers {label}
    </Badge>
  );
};

export default PreferredContactBadge;
